// #130 Sipariş/Belge kartı — Bekleyen / Araç / Planlanmadı kolonlarında kullanılır.
// HTML5 sürükle-bırak. Sol: belge no (gri) + müşteri (kalın) + tarih (gri).
// Sağ: koyu kg rozeti + haki tutar rozeti. Alt: Fat./İrs. chip + E-Belge rozeti.
import { docTypeShort, nextDocType, eDocMeta, fmtMoney, fmtNumber, fmtDate } from './shipmentPlanningUtils';

export function EDocBadge({ code, small }) {
  const m = eDocMeta(code);
  if (!m) return null;
  return (
    <span title={m.label} style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      padding: small ? '1px 6px' : '2px 8px', borderRadius: 6,
      fontSize: small ? 10 : 11, fontWeight: 800, lineHeight: 1.3,
      color: m.color, background: m.bg, border: `1px solid ${m.color}33`, whiteSpace: 'nowrap',
    }}>
      <span aria-hidden="true" style={{ fontSize: small ? 9 : 10 }}>⚡</span>
      {m.short || m.label}
    </span>
  );
}

export function DocTypeChip({ value, onToggle, disabled }) {
  const isWaybill = value === 'IRSALIYE';
  return (
    <button type="button" disabled={disabled}
      onClick={(e) => { e.stopPropagation(); if (!disabled) onToggle?.(nextDocType(value)); }}
      title="Belge türünü değiştir (Fatura / İrsaliye)"
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 4,
        padding: '2px 9px', borderRadius: 999, fontSize: 11, fontWeight: 800,
        cursor: disabled ? 'default' : 'pointer', whiteSpace: 'nowrap',
        color: isWaybill ? '#92400e' : '#1e40af',
        background: isWaybill ? 'rgba(253,171,61,0.14)' : 'rgba(0,115,234,0.12)',
        border: `1px solid ${isWaybill ? 'rgba(253,171,61,0.35)' : 'rgba(0,115,234,0.30)'}`,
      }}>
      {!disabled && <span aria-hidden="true" style={{ fontSize: 9, opacity: 0.75 }}>⇄</span>}
      {docTypeShort(value)}
    </button>
  );
}

export default function OrderCard({
  order, selected, onSelect, onDocTypeChange, onDragStart, onDragEnd,
  rightSlot, compact, adjusted, seq,
}) {
  return (
    <div
      draggable
      onDragStart={(e) => { e.dataTransfer.effectAllowed = 'move'; onDragStart?.(order); }}
      onDragEnd={() => onDragEnd?.()}
      onClick={() => onSelect?.(order)}
      className="sp-order-card"
      style={{
        position: 'relative',
        display: 'flex', flexDirection: 'column', gap: 7,
        padding: compact ? '9px 11px 9px 13px' : '11px 12px 11px 14px',
        border: `1px solid ${selected ? 'var(--accent)' : 'var(--border-color,#e5e7eb)'}`,
        borderRadius: 12,
        background: selected ? 'rgba(0,115,234,0.05)' : 'var(--bg-card,#fff)',
        boxShadow: selected ? '0 0 0 2px rgba(0,115,234,0.18)' : '0 1px 3px rgba(15,23,42,0.05)',
        cursor: 'grab', userSelect: 'none', transition: 'box-shadow 0.15s ease, transform 0.15s ease, border-color 0.15s ease',
        overflow: 'hidden',
      }}
    >
      {/* Sol seçim/sürükleme aksanı */}
      <span style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 3, background: selected ? 'var(--accent)' : 'transparent' }} />

      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
        {seq != null && (
          <span style={{ width: 18, height: 18, borderRadius: '50%', background: 'var(--accent)', color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 10, flexShrink: 0, marginTop: 1 }}>{seq}</span>
        )}
        <span aria-hidden="true" style={{ color: '#cbd5e1', cursor: 'grab', fontSize: 13, lineHeight: 1.6, flexShrink: 0 }}>⋮⋮</span>
        <div style={{ flex: 1, minWidth: 0 }}>
          {order.documentNo && (
            <div style={{ fontSize: 10.5, fontWeight: 700, color: 'var(--text-secondary,#94a3b8)', letterSpacing: 0.2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {order.documentNo}
            </div>
          )}
          <div style={{ fontWeight: 800, fontSize: 13, color: 'var(--text-primary,#0f172a)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {order.customerName}
          </div>
          <div style={{ fontSize: 11, color: 'var(--text-secondary,#94a3b8)', fontWeight: 600 }}>
            {fmtDate(order.documentDate)}
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4, flexShrink: 0 }}>
          <span style={{ fontSize: 10.5, fontWeight: 800, color: '#fff', background: '#1f2937', borderRadius: 999, padding: '2px 8px', whiteSpace: 'nowrap' }}>
            {fmtNumber(order.totalWeight)} kg
          </span>
          <span style={{ fontSize: 10.5, fontWeight: 800, color: '#6b6f1e', background: 'rgba(132,134,46,0.16)', border: '1px solid rgba(132,134,46,0.32)', borderRadius: 999, padding: '2px 8px', whiteSpace: 'nowrap' }}>
            {fmtMoney(order.netAmount)} ₺
          </span>
          {rightSlot}
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
        <DocTypeChip value={order.documentType} onToggle={(v) => onDocTypeChange?.(order, v)} />
        <EDocBadge code={order.eDocumentType} small />
        {adjusted && (
          <span title="Stok kontrolünde miktar güncellendi" style={{
            fontSize: 10, fontWeight: 800, color: '#92400e', background: 'rgba(253,171,61,0.16)',
            border: '1px solid rgba(253,171,61,0.35)', borderRadius: 6, padding: '1px 6px',
          }}>düzeltildi</span>
        )}
      </div>
    </div>
  );
}
